module.exports = __webpack_public_path__ + "img/fiverr logo.6085b21e.png";